import React, { useEffect, useState } from 'react';
import { Form, Select, Button } from 'antd';
import { useCrmCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';
import { CrmEditModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';

interface FormItemProps {
  form: any;
  company: number;
  company_name: string;
  view_info?: boolean;
  field_name?: string;
  insertCrmId?: string|number;
  addCrm?: CrmSaveReqDto; 
  required?: boolean;  
  onSelected?: (value: string|number, option: any) => void;
  onInsertCompleted?: (value: number, field: string) => void;
}

const CrmFormItem = ({form, company, company_name, view_info=false, field_name='crm_srl', insertCrmId, addCrm, required=false,onSelected, onInsertCompleted}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [companySrl, setCompanySrl] = useState<number>(company);
  const [crmInfo, setCrmInfo] = useState<string>('');
  const { open } = usePopupManager();  

  /* ======================================================
  * hooks
  * ====================================================== */


  const { codeList, refetch } = useCrmCode({params: {company: companySrl}});  

  /* ======================================================
  * events
  * ====================================================== */  
  
  const onClickRegister = () => {
    open(CrmEditModal, {
      id: 0,
      company_srl: companySrl,
      company_name: company_name,                  
      fixCompany: true,
      addCrm: addCrm,
      onClose: (isOk, id) => {
        if (isOk) {
          form.setFieldValue(field_name, id);  
          onInsertCompleted?.(id, field_name)    
          
          refetch(); 
        };
      },
    });     
  }

  const onChangeCrm = (value, option) => {
    setCrmInfo('전화번호: '+option.phone+' 이메일: '+option.email)
    if (onSelected) onSelected(value, option);
  }

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    if (companySrl != company) {
      if (!!companySrl) {
        form.setFieldValue(field_name, undefined);
      }
      setCompanySrl(company);
    }
  }, [company]);

  useEffect(() => {
    setCrmInfo('');
    if (!!codeList) {
      const result = codeList.find((item) => item.value === form.getFieldValue(field_name))
      if (!!result) {
        setCrmInfo('전화번호: '+result.phone+' 이메일: '+result.email);
        if (onSelected) onSelected(result.value , result);
      }
    }
  }, [codeList]);

  useEffect(() => {
    if (!!insertCrmId) {
      refetch();
    }
  }, [insertCrmId]);
  
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name={field_name} style={{ width:'180px', display: 'inline-block', marginRight: '10px' }} rules={[{ required: required, message: '' }]}>
        <Select 
          placeholder="CRM 선택" 
          options={codeList} 
          virtual={false}
          showSearch={true} 
          optionFilterProp="label"   
          onChange={(value, option) => onChangeCrm(value, option) }  
          filterOption={selectBoxFilterOption}                       
        />                
      </Form.Item>   
      <Button onClick={onClickRegister} type="primary" style={{ display: 'inline-block'}} disabled={!company || company===0}>CRM 등록</Button>
      {view_info && (<label style={{marginLeft:'10px'}}>{crmInfo}</label>)}
    </>
  );
};

export default CrmFormItem;
